import React, { useEffect, useState } from 'react'
import { useGetContactByIdQuery, useGetContactDetailsInProjectQuery } from '../../../../services/EndPointsApis'
import { useStateManager } from 'react-select'
import GoogleMapsProperty from './GoogleMap'
import { Link, useNavigate } from 'react-router-dom'
import MapQuestMap from './MapQuest'

const PropertyResource = ({ projectId, clientViewSummary }: any) => {
    const [showMap, setshowMap] = useState(true)
    const [showMapQuest, setshowMapQuest] = useState(false)
    const { data } = useGetContactDetailsInProjectQuery({ ProjectId: projectId })

    const navigate = useNavigate()
    const handleGoogleMap = () => {
        setshowMap(!showMap)
        setshowMapQuest(false)
    }
    const handleMapQuest = () => {
        setshowMapQuest(!showMapQuest)
        setshowMap(false)

    }
    return (
        <div className='card'>
            <div className='card-body card-css'>
                <div className='row'>
                    <div className='col-md-5'>
                        <div>
                            <h5>
                                Property Address
                            </h5>
                            <div className='mt-3'>
                                <div>
                                {data?.result?.primaryContactVMs?.propertyAddress?.addressLine1}
                                </div>
                                 <div>
                                {data?.result?.primaryContactVMs?.propertyAddress?.addressLine2}
                                </div>
                                 <div>
                                {data?.result?.primaryContactVMs?.propertyAddress?.cityName} {data?.result?.primaryContactVMs?.propertyAddress?.stateName && data?.result?.primaryContactVMs?.propertyAddress?.cityName  ? ',': '' } {data?.result?.primaryContactVMs?.propertyAddress?.stateName}  {data?.result?.primaryContactVMs?.propertyAddress?.zipCode && data?.result?.primaryContactVMs?.propertyAddress?.stateName ? ',': '' } {data?.result?.primaryContactVMs?.propertyAddress?.zipCode}
                                </div>
                                
                            </div>
                        </div>
                        <div className='mt-3'>
                            <h5>
                                View Maps:
                            </h5>
                            <p className='mt-2 mb-1 color-red text-decoration-underline cursor-pointer' onClick={handleGoogleMap}>
                                Google Map
                            </p>
                            {/* <a  href="https://search.yahoo.com"  className='mt-2 color-red text-decoration-underline cursor-pointer'>
                                Yahoo Map
                            </a>
                            <p className='mt-1 color-red text-decoration-underline cursor-pointer' onClick={handleMapQuest}>
                                Map Quest
                            </p> */}
                        </div>
                    </div>
                    {showMap &&
                        <div className='col-md-7'>
                            <div className='d-flex justify-content-end'>
                                <GoogleMapsProperty />
                            </div>
                        </div>
                    }
                    {showMapQuest &&
                        <div className='col-md-7'>
                            <div className='d-flex justify-content-end'>
                                <MapQuestMap />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default PropertyResource